export default __webpack_public_path__ + "static/17_VeganProclamation-ad23c6f67b3e4f3c5b51c00f2b40cf39.pdf";